import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import {
  Visibility as ViewIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import type { Location } from '../../types/vrp';

interface LocationActionsProps {
  location: Location;
  onView: (location: Location) => void;
  onEdit: (location: Location) => void;
  onDelete: (location: Location) => void;
}

export const LocationActions: React.FC<LocationActionsProps> = React.memo(({
  location,
  onView,
  onEdit,
  onDelete,
}) => {
  const handleView = (e: React.MouseEvent) => {
    e.stopPropagation();
    onView(location);
  };

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    onEdit(location);
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete(location);
  };

  return (
    <>
      <Tooltip title="View Details">
        <IconButton
          size="small"
          onClick={handleView}
          aria-label={`View details for ${location.name}`}
        >
          <ViewIcon />
        </IconButton>
      </Tooltip>      
      <Tooltip title="Edit Location">
        <IconButton
          size="small"
          onClick={handleEdit}
          aria-label={`Edit ${location.name}`}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
      
      <Tooltip title="Delete Location">
        <IconButton
          size="small"
          onClick={handleDelete}
          sx={{ color: 'error.main' }}
          aria-label={`Delete ${location.name}`}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </>
  );
});

LocationActions.displayName = 'LocationActions';
